import React from "react";
import { Navigate } from "react-router-dom";
import { isCurrentSession } from "../../utils/session";

const ProtectedRoute = ({ element }) => {
  if (isCurrentSession()) return element;

  // Session absente, ou ouverte avant le passage aux organisations : on repart
  // d'un localStorage vide pour forcer une reconnexion complète.
  localStorage.clear();
  return <Navigate to="/" replace />;
};

export default ProtectedRoute;
